import FormattedDateWithDefaults from "./FormattedDateWithDefaults"

import { event } from "@templates/press.module.css"

const NewsLink = ({ post }) => {
  return (
    <div className={event} key={post.id}>
      <h4>
        <a href={post.url.url} target="_blank" rel="noopener noreferrer">
          {post.title}
        </a>
      </h4>
      <p>
        {post.author}
        <br />
        <FormattedDateWithDefaults value={post.date} />
      </p>
      <hr />
    </div>
  )
}

export default NewsLink
